import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import s from './Radio.module.css';

const handleChange = (e, onChange) => {
  const { checked } = e.target;
  if (onChange) {
    onChange(checked, e);
  }
};

const Radio = ({ className, children, error, onClick, onChange, disabled, checked, ...props }) => {
  const [focused, setFocused] = useState(false);

  return (
    <label
      onClick={onClick}
      className={cn(s.root, className, {
        [s.checked]: !!checked,
        [s.error]: error,
        [s.focused]: focused,
        [s.disabled]: disabled,
      })}
    >
      <input
        className={s.input}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        type="radio"
        checked={checked}
        disabled={disabled}
        onChange={e => handleChange(e, onChange)}
        {...props}
      />
      <span className={s.inner}>
        <span className={s.circle} />
        {children && (
          <span className={s.label}>
            {children}
            {error && <span className={s.hint}>{error}</span>}
          </span>
        )}
      </span>
    </label>
  );
};

Radio.propTypes = {
  children: PropTypes.node,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  error: PropTypes.string,
};

Radio.defaultProps = {
  disabled: false,
  children: undefined,
  checked: undefined,
  error: undefined,
  onChange: undefined,
};

export default Radio;
